<template>
  <a-card class="NormComputeSet">
    <div @click="rawScoreTableClose">
      <a-form-model :style="step === 2 && 'pointer-events: none'" :model="ruleForm.data" :rules="ruleForm.rule" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" ref="ruleForm">
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="采集设备" ref="deviceTypes" prop="deviceTypes" :label-col="{ span: 4 }">
              <a-select mode="multiple" style="min-width: 180px" allowClear v-model="ruleForm.data.deviceTypes" placeholder="请选择">
                <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id" :disabled="isDeviceTypeDisabled(item)">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="粗分阈限" class="age">
              <div class="age-cont" :data-age="age">
                <a-form-model-item :wrapper-col="{ span: 24 }" prop="minSocre">
                  <a-input-number v-model="ruleForm.data.minSocre" style="width: 100%" />
                </a-form-model-item>
                <span style="margin: 0 10px 20px">-</span>
                <a-form-model-item :wrapper-col="{ span: 24 }" prop="maxScore">
                  <a-input-number v-model="ruleForm.data.maxScore" style="width: 100%" />
                </a-form-model-item>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="采集时间段" ref="times">
              <a-range-picker
                v-model="ruleForm.times"
                :disabled-date="(current) => current && current > moment().endOf('day')"
                :show-time="{ format: 'HH:mm' }"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
              />
            </a-form-model-item>
          </a-col>
          <a-col v-show="step === 1" :span="3" style="margin-top: 4px; margin-left: 70px">
            <a-button @click="createTable(1)" type="primary" style="margin-right: 30px" :loading="ruleForm.loading">生成 </a-button>
            <a-button @click="reset()">恢复</a-button>
          </a-col>
        </a-row>
        <a-row style="padding: 0 20px" type="flex" justify="space-between">
          <a-col>
            <a-checkbox v-model="ruleForm.area"> 区域代表性 </a-checkbox>
            <span v-show="ruleForm.area" style="position: relative">
              <a-input-number v-model="ruleForm.data.areaCharacteristicSize" :disabled="!ruleForm.area" style="width: 150px; margin: 0 20px 0 10px" />
              <template v-if="ruleForm.data.areaCharacteristicSize > 0">
                <span class="area" :class="{ 'areas-active': ruleForm.areaSelects.some((v) => v.id == item.id) }" v-for="(item, index) in areas" @click="areaClick(item)" :key="index">{{
                  item.label
                }}</span>
              </template>
              <p class="errMsg" v-if="ruleForm.errMsg">请填写区域样本量</p>
            </span>
          </a-col>
          <a-col>
            <a-form-model-item label="课程范围" v-if="step == 1">
              <a-input class="course-input" :value="addCourseName" placeholder="选择课程" style="width: 240px" :readOnly="true">
                <a-span slot="suffix" style="color: var(--color)" @click="openSelectCourse">{{ ruleForm.data.courses.length ? '点击替换' : '点击选择' }}</a-span>
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <div v-show="step === 1">
        <div class="content">
          <div class="head">
            <h1>常模对比表</h1>
            <div class="btns" style="width: 200px">
              <a-button v-if="lastVersionnorm" @click="getLastVersionNorm()">{{ lastVersionnorm }}版本 </a-button>
              <!-- <a-button >3.15版本</a-button> -->
              <a-button @click="exportView()">导出</a-button>
            </div>
          </div>
          <div class="table" style="padding: 0 19px; margin-top: 15px" @click.stop>
            <a-table
              :columns="contrastColumns"
              row-key="id"
              :row-selection="rowSelection"
              :scroll="{ y: 480 }"
              :pagination="false"
              :customRow="customRow"
              :loading="contrastStr.loading"
              :dataSource="contrastStr.tableRelevant.tableDataSource"
            >
              <div slot="gender" slot-scope="text">
                {{ text.gender == 0 ? '全部' : text.gender == 1 ? '男' : '女' }}
              </div>
              <div slot="existsSampleCount" slot-scope="text">
                {{ text.existsSampleCount }}
              </div>
              <div slot="existsSampleAvgScore" slot-scope="text">
                {{ text.existsSampleAvgScore ? text.existsSampleAvgScore : '--' }}
              </div>
              <div slot="existsSampleStd" slot-scope="text">
                {{ text.existsSampleStd ? text.existsSampleStd : '--' }}
              </div>
              <div slot="average" slot-scope="text">
                <div class="box" @click.stop="rawScoreTableClose">
                  <input @blur="changeThisSampleAvgScore($event, text)" class="table-input" type="number" :value="text.average" />
                  <span class="people" v-if="text.thisAvgScoreHasUpdate">人工</span>
                </div>
              </div>
              <div slot="standardDeviation" slot-scope="text">
                <div class="box" @click.stop="rawScoreTableClose">
                  <input @blur="changeThisSampleStd($event, text)" class="table-input" type="number" :value="text.standardDeviation" />
                  <span class="people" v-if="text.thisStdHasUpdate">人工</span>
                </div>
              </div>
            </a-table>
          </div>
        </div>
        <div class="content">
          <div class="head">
            <h1>年龄发展趋势 <span>( 以年龄为横轴 )</span></h1>
            <div class="genders">
              <div @click="changeGender(item.id)" :class="ageChart.current == item.id ? 'active item' : 'item'" v-for="item in ageChart.genders" :key="item.id">{{ item.name }}</div>
            </div>
          </div>
          <div class="ageChart">
            <div id="AgeChart" style="height: 290px; width: 100%"></div>
            <div id="AgeChartContent" v-if="!TableCreated" style="height: 290px; width: 100%; display: flex; align-items: center; justify-content: center">暂无数据</div>
          </div>
        </div>

        <div class="rawScore" v-show="rawScore.visible">
          <div class="rawScoreChart">
            <div class="head">
              <h1>粗分分布图 <span>( 以粗分组为横轴 )</span></h1>
              <div class="groupedNum">
                分组数：
                <a-input-number v-model="rawScore.groupedNum" :min="1" @change="changeGrouped" style="width: 40%" />
                <!-- <span><a-icon type="caret-up" @click="addNum()"/><a-icon type="caret-down" @click="reduceNum()"/></span> -->
              </div>
              <a-icon type="close" @click="rawScoreTableClose" />
            </div>
            <div class="chart">
              <p :style="`text-align: center;opacity: ${rawScore.average || rawScore.std ? 1 : 0};`">
                <span>选择数据的平均分：{{ rawScore.average }} </span>
                <span style="margin-left: 50px">选择数据的标准差：{{ rawScore.std }}</span>
              </p>
              <div id="RawScoreChart" style="height: 300px; width: 100%"></div>
              <div style="text-align: right; padding-right: 50px">
                <a-button @click="rawScoreTableClose" style="margin-right: 15px">取消</a-button>
                <a-button @click="updateTableData" type="primary">确认</a-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <norm-info ref="normInfo" v-show="step === 2" />

      <footer-tool-bar>
        <div class="btns">
          <template v-if="step === 1">
            <a-button @click="backpage()">返回</a-button>
            <a-button type="primary" @click="nextStep" :disabled="!contrastStr.tableRelevant.tableDataSource.length">下一步</a-button>
          </template>
          <template v-else>
            <a-button @click="step = 1" :disabled="submitLoading">上一步</a-button>
            <a-button type="primary" ghost @click="audit()" :disabled="submitLoading"> 提交审核 </a-button>
            <a-button type="primary" @click="audit('onlySub')" :disabled="submitLoading"> 保存更改 </a-button>
          </template>
        </div>
      </footer-tool-bar>
    </div>

    <!-- 版本常模列表 -->
    <a-modal :centered="true" v-model="versions.visible" :title="versions.title" :confirm-loading="versions.confirmLoading" :footer="false" width="800px">
      <div class="search">
        <a-form-model layout="inline" :model="versions.searchForm">
          <a-form-model-item label="应用设备">
            <a-select class="serach-item" mode="multiple" show-search allowClear v-model="versions.searchForm.deviceType" placeholder="请选择">
              <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item style="margin-right: 35px">
            <a-button @click="getList(1)" type="primary" html-type="button"> 查询 </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="table">
        <a-table
          :columns="versionsColumns"
          row-key="id"
          :pagination="versions.tableRelevant.tablePagination"
          :loading="versions.tableRelevant.tableLoading"
          :locale="versions.tableRelevant.locale"
          :dataSource="versions.tableRelevant.tableDataSource"
        >
          <div slot="name" slot-scope="text">
            <span v-for="item in text.name" :key="item.id">
              {{ item.name + '  ' }}
            </span>
          </div>
          <div slot="ybl" slot-scope="text">
            {{ text.ybl > 0 ? text.ybl : '--' }}
          </div>
          <div slot="dbqy" slot-scope="text">
            <span v-if="!text.provinceList.length">--</span>
            <template v-else>
              <span v-for="(item, index) in text.provinceList" :key="index">
                {{ item + '  ' }}
              </span>
            </template>
          </div>
          <div slot="action" slot-scope="text">
            <a @click="view(text)" style="margin-right: 8px">查看</a>
            <a @click="download(text)" style="margin-right: 8px">记录</a>
          </div>
        </a-table>
      </div>
    </a-modal>
    <!-- 历史版本 -->
    <a-modal :centered="true" v-model="history.visible" :title="history.title" :footer="false" width="70%">
      <NormComputeDetail :historyDatail="true" :lastId="history.id" :lastDeviceType="history.deviceType"></NormComputeDetail>
    </a-modal>

    <select-course v-model="selectCourse.visible" :courses="ruleForm.data.courses" :contentId="$route.query.contentId" @ok="confirmSelectCourse" />
  </a-card>
</template>

<script>
import FooterToolBar from '@/components/tool/FooterToolBar'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'
import xlsx from 'xlsx'
import NormComputeDetail from './NormComputeDetail' //常模计算
import NormInfo from './NormInfo.vue'
import SelectCourse from './SelectCourse.vue'

const contrastColumns = [
  { title: '年龄', dataIndex: 'age', align: 'center' },
  { title: '性别', scopedSlots: { customRender: 'gender' }, align: 'center' },
  { title: '本次样本量', dataIndex: 'sampleCount', align: 'center' },
  { title: '已有样本量', scopedSlots: { customRender: 'existsSampleCount' }, align: 'center' },
  { title: '本次平均分', scopedSlots: { customRender: 'average' }, align: 'center', width: 250 },
  { title: '已有平均分', scopedSlots: { customRender: 'existsSampleAvgScore' }, align: 'center' },
  { title: '本次标准差', scopedSlots: { customRender: 'standardDeviation' }, align: 'center', width: 250 },
  { title: '已有标准差', scopedSlots: { customRender: 'existsSampleStd' }, align: 'center' },
]
const versionsColumns = [
  { title: '应用设备', scopedSlots: { customRender: 'name' }, align: 'left' },
  { title: '样本量', scopedSlots: { customRender: 'ybl' }, align: 'center' },
  { title: '代表区域', scopedSlots: { customRender: 'dbqy' } },
  { title: '更新时间', dataIndex: 'updateTime', align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center' },
]

export default {
  name: 'NormComputeSet',
  components: { FooterToolBar, NormComputeDetail, NormInfo, SelectCourse },
  data() {
    return {
      moment,
      step: 1,
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
      // 生成数据
      ruleForm: {
        loading: false,
        area: false,
        areaSelects: [],
        errMsg: false,
        times: [],

        data: {
          deviceTypes: [16],
          minSocre: undefined,
          maxScore: undefined,
          startTime: undefined,
          endTime: undefined,
          areaCharacteristicSize: undefined,
          contentAbilityId: this.$route.query.id,
          contentVersion: this.$route.query.version || '1.0.0',
          courses: [],
        },
        rule: {
          deviceTypes: [{ required: true, message: '请选择设备', trigger: 'change' }],
          minSocre: [
            { required: false, message: '请填写最小值', trigger: 'blur' },
            { min: 1, message: '最小值为1', trigger: ['change', 'blur'], type: 'number' },
          ],
          maxScore: [
            { required: false, message: '请填写最大值', trigger: 'blur', type: 'number' },
            { min: 1, message: '最小值为1', trigger: ['change', 'blur'], type: 'number' },
          ],
        },
      },
      // 常模对比表
      contrastColumns,
      contrastStr: {
        loading: false,
        tableRelevant: tableRelevant.call(this, this.getList),
        dataJson: {},
      },
      // 点击行
      customRow: (record, index) => ({
        on: {
          click: () => {
            this.rawScoreTableClose()
            if (record.sampleCount < 50) {
              this.$message.destroy()
              this.$message.warning('数据不足')
            } else {
              this.rawScore.index = index
              this.getApproximateScores(record)
            }
          },
        },
      }),
      // 粗分分布图
      rawScore: {
        visible: false,
        groupedNum: 100, //分组数
        average: 0,
        std: 0,
        index: 0,
        Arr: [],
        thisData: [],
        existsData: [],
      },
      //年龄发展趋势
      ageChart: {
        genders: [
          { id: 0, name: '全部' },
          { id: 1, name: '男' },
          { id: 2, name: '女' },
        ],
        current: 0,
        xAxis: [],
        yAxis: [],
        stds: [],
      },

      versionsColumns,
      versions: {
        searchForm: {
          deviceType: [],
        },
        visible: false,
        title: '常模记录',
        confirmLoading: false,
        tableRelevant: tableRelevant.call(this, this.getList),
      },
      areas: [],
      excelTitle: '',
      lastVersionnorm: '', //上一版本
      sampleSize: this.$route.query.sampleSize ? this.$route.query.sampleSize : '', //样本量
      TableCreated: false,

      // 历史版本
      history: {
        id: '',
        visible: false,
        title: '3.169版本',
        deviceType: '',
        data: {},
      },
      normId: '',
      submitId: '',
      submitLoading: false,
      tableSelectedRowKeys: [],
      selectCourse: {
        visible: false,
      },
    }
  },
  mounted() {
    let name = sessionStorage.getItem('currentName')
    let version = this.$route.query.version
    if (version) {
      this.excelTitle = name + '(' + version + ')' + ' 常模配置'
    } else {
      this.excelTitle = name + ' 常模配置'
    }

    this.$store.commit(
      'account/set_breadcrumb',
      this.$store.state.account.breadcrumb
        .map((m) => {
          if (m.name === '常模配置') {
            m.path = this.$store.getters['content/getNormInfo']().fullPath
          }
          return m
        })
        .filter((f) => f.name !== '常模配置' || typeof f.path !== 'undefined')
    )

    if (this.$route.query.recordId) {
      this.getDetail(this.$route.query.recordId)
      this.normId = this.$route.query.recordId
    }
    // this.createTable();
  },
  computed: {
    addCourseName() {
      if (this.ruleForm.data.courses?.length) {
        return this.ruleForm.data.courses?.map((v) => v.name).join('，')
      }
      return '全部'
    },
    rowSelection() {
      return {
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.tableSelectedRowKeys = selectedRowKeys
        },
      }
    },
    age() {
      this.ruleForm.rule.maxScore[1].min = this.ruleForm.data.minSocre
      this.ruleForm.rule.maxScore[1].message = `最大值需大于 ${this.ruleForm.data.minSocre} `
      return this.ruleForm.data.minSocre + '-' + this.ruleForm.data.maxScore
    },
  },
  watch: {
    'ruleForm.area'(val) {
      if (!val) {
        this.ruleForm.data.areaCharacteristicSize = undefined
        console.log(this.ruleForm.data.areaCharacteristicSize)
      }
    },
    'ruleForm.data.areaCharacteristicSize'(val) {
      if (val) {
        this.ruleForm.errMsg = false
      } else {
        this.ruleForm.errMsg = true
      }
    },
    'ruleForm.times'(val) {
      if (Object.prototype.toString.call(val[0]) == '[object Object]') {
        this.ruleForm.data.startTime = val[0]._i
        this.ruleForm.data.endTime = val[1]._i
        return
      }
      this.ruleForm.data.startTime = val[0]
      this.ruleForm.data.endTime = val[1]
    },
  },
  methods: {
    isDeviceTypeDisabled(item) {
      const deviceType = this.ruleForm.data.deviceTypes.reduce((deviceType, v) => deviceType | v, 0)
      if (deviceType == 0) return false
      if (deviceType & 16 && item.id != 16) {
        return true
      }
      if (!(deviceType & 16) && item.id == 16) {
        return true
      }
      return false
    },
    areaClick(area) {
      if (this.ruleForm.areaSelects.some((item) => item.id == area.id)) {
        this.ruleForm.areaSelects = this.ruleForm.areaSelects.filter((item) => item.id != area.id)
      } else {
        this.ruleForm.areaSelects.push(area)
      }
    },
    confirmSelectCourse(courses) {
      this.ruleForm.data.courses = courses
    },
    openSelectCourse() {
      this.selectCourse.visible = true
    },
    getLastVersionNorm() {
      this.history.visible = true
    },
    // 导出
    exportView() {
      const arr = [contrastColumns.map((m) => m.title)]
      arr[0].unshift('游戏名称')
      let data = this.contrastStr.tableRelevant.tableDataSource
      data.forEach((f) => {
        arr.push([
          sessionStorage.getItem('currentName') + 'v' + this.$route.query.version,
          f.age,
          f.gender == 0 ? '全部' : f.gender == 1 ? '男' : '女',
          f.sampleCount,
          f.existsSampleCount,
          f.average,
          f.existsSampleAvgScore,
          f.standardDeviation,
          f.existsSampleStd,
        ])
      })
      const aoa = xlsx.utils.aoa_to_sheet(arr)
      const book = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(book, aoa, '第一页')
      xlsx.writeFile(book, this.excelTitle + '.xlsx')
    },
    onChange() {},
    getDetail(id) {
      let params = {
        id,
      }
      this.$http.NormSet.getDetail(params)
        .then((res) => {
          const { status, data, message } = res
          this.TableCreated = status

          for (let key in data) {
            for (let k in this.ruleForm.data) {
              if (key == k && key != 'deviceType') {
                this.ruleForm.data[key] = data[key] == null ? undefined : data[key]
              }
            }
          }
          this.history.id = data.lastVersionId
          this.history.deviceType = data.deviceType > 8 ? 1 : data.deviceType
          this.history.title = data.lastVersionnorm
          this.ruleForm.data.deviceTypes = this.equipmentList.filter((f) => (f.id | data.deviceType) === data.deviceType).map((m) => m.id)
          this.ruleForm.data.areaCharacteristicSize = data.areaCharacteristicSize || undefined
          if (data.areaCharacteristicSize) {
            this.ruleForm.area = true
          }
          if (data.areaCharacteristicDescriptions && data.areaCharacteristicDescriptions != '[]') {
            try {
              this.areas = JSON.parse(data.areaCharacteristicDescriptions)
              this.ruleForm.areaSelects = [...this.areas]
            } catch (error) {
              this.areas = []
              this.ruleForm.areaSelects = []
              console.log(error)
            }
          }
          data.norms.forEach((v, i) => {
            v.index = i
          })
          this.lastVersionnorm = data.lastVersionnorm
          if (data.startTime && data.endTime) {
            this.ruleForm.times = [moment(data.startTime), moment(data.endTime)]
          }
          // this.$set(this.ruleForm, "time", [moment(data.startTime), moment(data.endTime)])
          this.createNorm(data.norms)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 生成
    createNorm(data) {
      this.contrastStr.tableRelevant.tableDataSource = data
      this.tableSelectedRowKeys = data.map((m, i) => i)
      this.contrastStr.dataJson = JSON.stringify(data)
      let thisData = data.filter((m) => m.gender == 0)
      thisData.forEach((v) => {
        this.ageChart.xAxis.push(v.age || 0)
        this.ageChart.yAxis.push(v.average || 0)
        this.ageChart.stds.push(v.standardDeviation || 0)

        // this.rawScore.thisData.push()
        // this.rawScore.existsData.push()
      })
      this.$nextTick(() => {
        this.AgeChart()
      })
    },
    // 获取粗分
    getApproximateScores(record) {
      let params = {
        NormId: this.submitId ? this.submitId : this.normId,
        Age: record.age,
        Gender: record.gender,
      }
      this.$http.NormSet.GetApproximateScores(params).then((res) => {
          if (res.data.length) {
            this.rawScore.visible = true
            this.rawScore.Arr = res.data
            this.RawScoreChart(res.data)
          } else {
            this.$message.destroy()
            this.$message.warning('数据不足')
          }
      
      })
    },
    // 初次生成
    createTable() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.ruleForm.data.areaCharacteristicSize && this.ruleForm.area) {
            this.ruleForm.errMsg = true
            return
          }
          this.contrastStr.loading = true
          this.ageChart.xAxis = []
          this.ageChart.yAxis = []
          this.ruleForm.loading = true
          this.ruleForm.data.maxScore = typeof this.ruleForm.data.maxScore != 'number' ? undefined : this.ruleForm.data.maxScore
          this.ruleForm.data.minSocre = typeof this.ruleForm.data.minSocre != 'number' ? undefined : this.ruleForm.data.minSocre
          const params = { ...this.ruleForm.data }
          params.courseIds = params.courses.map((v) => v.id)
          if (this.ruleForm.areaSelects.length) {
            params.regionIds = this.ruleForm.areaSelects.map((v) => v.id)
          }
          delete params.courses
          this.$http.NormSet.GetNormalContrastData(params)
            .then((res) => {
              this.contrastStr.loading = false
              this.ruleForm.loading = false
              const { status, data, messge } = res
              this.TableCreated = status

              this.normId = data.normId
              // if (!params.regionIds) {
              this.areas = []
              if (data.provinces) {
                Object.keys(data.provinces).forEach((key) => {
                  this.areas.push({ id: key, label: data.provinces[key] })
                })
              }
              this.ruleForm.areaSelects = [...this.areas]
              // }
              this.sampleSize = data.sampleSize
              data.items.forEach((v, i) => {
                v.index = i
              })
              this.contrastStr.tableRelevant.tableDataSource = data.items
              this.tableSelectedRowKeys = data.items.map((m, i) => i)
              this.contrastStr.dataJson = JSON.stringify(data.items)
              let thisData = data.items.filter((m) => m.gender == 0)
              thisData.forEach((v) => {
                this.ageChart.xAxis.push(v.age || 0)
                this.ageChart.yAxis.push(v.average || 0)
                this.ageChart.stds.push(v.standardDeviation || 0)
              })
              this.$nextTick(() => {
                this.AgeChart()
              })
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 重置
    reset() {
      if (this.$route.query.recordId) {
        this.getDetail(this.$route.query.recordId)
      } else {
        // 采集设备默认全选

        this.ruleForm.data = {
          deviceTypes: [16],
          minSocre: undefined,
          maxScore: undefined,
          startTime: undefined,
          endTime: undefined,
          area: false,
          areaCharacteristicSize: undefined,
          contentAbilityId: this.$route.query.id,
          contentVersion: this.$route.query.version || '1.0.0',
          courses: [],
        }
        this.createTable()
      }
    },
    // 手动调试本次平均分
    changeThisSampleAvgScore(e, val) {
      if (String(e.target.value) === String(val.average)) {
        return
      }
      val.average = e.target.value
      val.thisAvgScoreHasUpdate = true
      this.rawScoreTableClose()
      this.$nextTick(() => {
        this.AgeChart()
      })
    },
    // 手动调试本次平均分
    changeThisSampleStd(e, val) {
      if (String(e.target.value) === String(val.thisStdHasUpdate)) {
        return
      }
      val.standardDeviation = e.target.value
      val.thisStdHasUpdate = true
      this.rawScoreTableClose()
      this.$nextTick(() => {
        this.AgeChart()
      })
    },

    // 年龄发展趋势 切换性别
    changeGender(gender) {
      this.ageChart.xAxis = []
      this.ageChart.yAxis = []
      this.ageChart.stds = []
      this.ageChart.current = gender
      let data = this.contrastStr.tableRelevant.tableDataSource.filter((m) => m.gender == gender)
      data.forEach((v) => {
        this.ageChart.xAxis.push(v.age || 0)
        this.ageChart.yAxis.push(v.average || 0)
        this.ageChart.stds.push(v.standardDeviation || 0)
      })
      this.$nextTick(() => {
        this.AgeChart()
      })
    },
    // 年龄发展趋势折线
    AgeChart() {
      const CharData = this.contrastStr.tableRelevant.tableDataSource.filter((f) => f.gender === this.ageChart.current)
      const AgeChartBox = document.getElementById('AgeChart')
      let AgeChart = this.$echarts.init(
        AgeChartBox,
        {},
        {
          renderer: 'svg',
        }
      )
      var option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: CharData.map((m) => m.age),
        },

        yAxis: {
          type: 'value',
        },
        tooltip: {
          trigger: 'axis',
          formatter: (val) => {
            return `<div>
                                <p>${val[0].name}</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(254,143,7);"></span>样本量：${
                                  CharData[val[0].dataIndex].sampleCount == null ? '' : CharData[val[0].dataIndex].sampleCount
                                }</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(7,93,254);"></span>平均分：${
                                  CharData[val[0].dataIndex].average || 0
                                }</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(228,240,255);"></span>标准差：${
                                  CharData[val[0].dataIndex].standardDeviation || 0
                                }</p>
                                <p></p>
                            </div>`
          },
        },
        series: [
          {
            name: '平均分',
            data: CharData.map((m) => m.average || 0),
            type: 'line',
            symbol: 'circle',
            // stack: 'Total',
            areaStyle: {
              color: 'rgb(228,240,255)',
              emphasis: {
                color: 'rgb(228,240,255)',
              },
            },
            lineStyle: {
              normal: {
                color: 'rgb(7,93,254)',
              },
            },
            itemStyle: {
              normal: {
                color: 'rgb(7,93,254)', //拐点颜色
                borderColor: 'rgb(7,93,254)', //拐点边框颜色
                borderWidth: 3, //拐点边框大小
              },
            },
            symbolSize: 5, //设定实心点的大小
          },
        ],
      }
      AgeChart.setOption(option)

      setTimeout(() => {
        var path = document.querySelectorAll("#AgeChart path[fill='rgb(7,93,254)']")
        var itemChar = document.querySelectorAll('#AgeChart .item-char')
        for (let i = 0; i < itemChar.length; i++) {
          itemChar[i].remove()
        }
        for (let i = 0; i < path.length; i++) {
          var split = path[i]
            .getAttribute('transform')
            .match(/(?<=\()(.+?)(?=\))/g)[0]
            .split(',')
          var div = document.createElement('div')
          div.innerHTML = '<span></span>'
          div.className = 'item-char'
          div.style.top = split[split.length - 1] + 'px'
          div.style.left = split[split.length - 2] + 'px'
          AgeChartBox.appendChild(div)
        }
      }, 700)
    },
    nextStep() {
      if (!this.tableSelectedRowKeys.length) {
        this.$message.error('请选择常模对比数据')
        return
      }
      this.$refs.normInfo.form.data.deviceType = this.ruleForm.data.deviceTypes
      this.step = 2
    },
    // 提交审核
    audit(btnStatus) {
      this.$refs.normInfo.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            id: this.submitId || this.$route.query.recordId,
            contentAbilityId: this.$route.query.id,
            ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
            AreaCharacteristicDescriptions: JSON.stringify(this.ruleForm.areaSelects),
            Status: btnStatus == 'onlySub' ? 0 : 1,
            NormId: this.normId,
            ...this.ruleForm.data,
            courses: undefined,
          }
          let tableSelectedRows = this.contrastStr.tableRelevant.tableDataSource.filter((f, i) => this.tableSelectedRowKeys.includes(i))

          for (let key in this.$refs.normInfo.form.data) {
            if (key !== 'deviceType') {
              params[key] = this.$refs.normInfo.form.data[key]
            }
          }
          params.deviceType = this.ruleForm.data.deviceTypes.reduce((a, b) => a + b, 0)
          delete params.deviceTypes
          params.Norms = JSON.stringify(tableSelectedRows)
          params.sampleSize = tableSelectedRows.reduce((a, b) => (b.age > 0 && (b.genderName === '全部' || b.gender === 0) ? a + b.sampleCount : a), 0)

          this.$http.NormSet.NormEdit(params).then((res) => {
            this.submitLoading = false
            const { status, data, message } = res

            this.$message.success(message)
            if (btnStatus == 'onlySub') {
              this.getDetail(data)
              this.submitId = data
            } else {
              this.backpage()
            }
          })
        }
      })
    },
    // 返回
    backpage() {
      this.$router.push(this.$store.getters['content/getNormInfo']().fullPath)
    },

    //切换分组数
    changeGrouped(value) {
      this.RawScoreChart(this.rawScore.Arr)
    },
    RawScoreChart() {
      var arr = this.rawScore.Arr.map((v) => v.toFixed(3))
      var min = Math.min.apply(null, arr)
      var max = Math.max.apply(null, arr)
      var spacing1 = (max - min) / (this.rawScore.groupedNum - 1)
      var spacing2 = (max - min) / this.rawScore.groupedNum
      const xAxisData = Array.from({ length: this.rawScore.groupedNum + 1 }, (m, i) => {
        return (min + spacing2 * i).toFixed(3)
      })
      var option = {
        xAxis: [
          {
            type: 'category',
            data: Array.from({ length: this.rawScore.groupedNum }, (m, i) => {
              return (min + spacing1 * i).toFixed(3)
            }),
            show: false,
          },
          {
            type: 'category',
            position: 'bottom',
            boundaryGap: false,
            data: xAxisData,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: {
          type: 'value',
        },
        series: [
          {
            barWidth: '100%',
            data: Array.from({ length: this.rawScore.groupedNum }, (m, i) => {
              if (i === this.rawScore.groupedNum - 1) {
                return arr.filter((f) => f >= min + spacing2 * i && f <= min + spacing2 * (i + 1)).length
              }
              return arr.filter((f) => f >= min + spacing2 * i && f < min + spacing2 * (i + 1)).length
            }),
            type: 'bar',
          },
        ],
        brush: {
          toolbox: ['lineX', 'keep', 'clear'],
          xAxisIndex: 0,
          brushStyle: {
            borderWidth: 1,
            color: 'rgba(19,194,194,0.68)',
            borderColor: 'transparent',
          },
        },
        toolbox: {
          showTitle: false,
          /*tooltip: { // 和 option.tooltip 的配置项相同
              show: true,
              formatter: function (param) {
                  if (param.name === "lineX") {
                      return "<div>横向选择</div>"
                  }
                  if (param.name === "lineX") {
                      return "保持选择"
                  }
                  return '清除选择';
              },

          }*/
        },
      }
      this.$nextTick(() => {
        // console.log(this.rawScore.Arr);
        const myChart = this.$echarts.init(document.getElementById('RawScoreChart'))
        myChart.setOption(option)
        myChart.dispatchAction({
          type: 'takeGlobalCursor',
          key: 'brush',
          brushOption: {
            brushType: 'lineX', // 指定选框类型
          },
        })
        myChart.on('brushEnd', (params) => {
          if (!params.areas[0]) {
            this.rawScore.average = 0
            this.rawScore.std = 0
            return
          }
          const list = this.rawScore.Arr.filter((f) => f >= xAxisData[params.areas[0].coordRange[0]] && f <= xAxisData[params.areas[0].coordRange[1] + 1])
          this.rawScore.average = list.length > 0 ? list.reduce((prev, curr) => prev + curr, 0) / list.length : 0
          this.rawScore.std = list.length > 1 ? Math.sqrt(list.map((m) => Math.pow(this.rawScore.average - m, 2)).reduce((prev, curr) => prev + curr, 0) / (list.length - 1)) : 0
        })
      })
    },
    updateTableData() {
      this.contrastStr.tableRelevant.tableDataSource[this.rawScore.index] = {
        ...this.contrastStr.tableRelevant.tableDataSource[this.rawScore.index],
        standardDeviation: this.rawScore.std,
        average: this.rawScore.average,
        thisStdHasUpdate: true,
        thisAvgScoreHasUpdate: true,
      }
      this.rawScoreTableClose()
    },
    rawScoreTableClose() {
      this.rawScore.visible = false
      this.rawScore.average = 0
      this.rawScore.std = 0
      const RawScoreChart = document.getElementById('RawScoreChart')
      RawScoreChart.innerHTML = ''
      RawScoreChart.removeAttribute('_echarts_instance_')
    },
  },
}
</script>

<style scoped lang="less">
.age /deep/ .ant-form-item {
  height: 59px;
  margin-bottom: 0;
}

.age-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btns .ant-btn {
  margin-left: 20px;
}

/deep/ .ant-calendar-picker-input {
  width: 300px;
}

.area {
  display: inline-block;
  padding: 0 10px;
  border: 1px dotted #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.content {
  margin-top: 50px;

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    h1 {
      font-weight: 600;
      margin: 0;

      span {
        font-size: 14px;
        color: #a0a0a0;
        font-weight: normal;
      }
    }

    .genders {
      display: flex;

      .item {
        padding: 0 20px;
        height: 30px;
        display: flex;
        border: 1px solid #ccc;
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
      }

      .active {
        border-color: rgb(0, 82, 217);
        color: rgb(0, 82, 217);
      }
    }
  }

  .ageChart {
    width: 100%;
    height: 350px;
    position: relative;
    overflow: hidden;

    #AgeChart {
      width: 100% !important;
      min-height: 300px;
    }

    #AgeChartContent {
      position: absolute;
      left: 0;
      top: 0;
      background-color: #fff;
    }

    /deep/ .item-char {
      width: 3px;
      height: 50px;
      background-color: rgb(255, 154, 51);
      position: absolute;
      transform: translate(-50%, -50%);

      &:before,
      &:after {
        content: '';
        background-color: rgb(255, 154, 51);
        width: 10px;
        height: 10px;
        display: block;
        position: absolute;
        left: -3.75px;
        top: 0;
        border-radius: 50%;
      }

      &:after {
        top: auto;
        bottom: 0;
      }

      span {
        width: 12px;
        height: 12px;
        background-color: rgb(7, 93, 254);
        border-radius: 50%;
        position: absolute;
        left: -4px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.table-input {
  border: none;
  width: 60%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: center;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rawScore {
  width: 60%;
  height: 480px;
  background: rgb(226, 226, 226);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 9;
  padding: 15px;
  border-radius: 5px;

  .rawScoreChart {
    width: 100%;
    background: #fff;
    height: 100%;
    border-radius: 5px;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 0 20px;

      h1 {
        font-weight: 600;
        margin: 0;

        span {
          font-size: 14px;
          color: #a0a0a0;
          font-weight: normal;
        }
      }

      .groupedNum {
        display: flex;
        align-items: center;
        width: 36%;
        justify-content: center;

        span {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          i {
            cursor: pointer;
          }
        }
      }
    }

    .chart {
      margin-top: 20px;
    }
  }
}

.box {
  display: flex;
  justify-content: space-around;

  .people {
    font-size: 12px;
    border: 1px solid #f00;
    border-radius: 5px;
    padding: 0 5px;
    color: #f00;
    cursor: pointer;
  }
}

.errMsg {
  color: #f00;
  font-size: 14px;
  position: absolute;
  left: 10px;
  top: 30px;
}

.course-input ::v-deep .ant-input:not(:last-child) {
  padding-right: 84px;
  text-overflow: ellipsis;
}
.areas-active {
  background-color: var(--color);
  color: #eee;
}
</style>
